import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";

export const Impressum = () => {
  // Local state to track the language
  const [lang, setLang] = useState("de");

  return (
    <section className="impressum" style={{ padding: "200px 0", color: "#fff" }}>
      <Container>
        {/* Title & language buttons on one row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "40px",
            flexWrap: "wrap",
            
          }}
        >
          {/* Heading: 'Impressum' (German) vs. 'Legal Disclosure' (English) */}
          <h2 style={{ marginBottom: "10px" }}>
            {lang === "en" ? "Legal Disclosure" : "Impressum"}
          </h2>
          {/* Buttons to switch the language */}
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant={lang === "de" ? "light" : "outline-light"}
              size="sm"
              onClick={() => setLang("de")}
            >
              Deutsch
            </Button>
            <Button
              variant={lang === "en" ? "light" : "outline-light"}
              size="sm"
              onClick={() => setLang("en")}
            >
              English
            </Button>
          </div>
        </div>

        {/* Content changes based on lang */}
        {lang === "de" ? (
          <>
            <p>
              <strong>Angaben gemäß § 5 TMG:</strong>
            </p>
            <p>
              Özkan Kizilkan
              <br />
              Freiligrathstraße 12  
              <br />
              10967 Berlin  
              <br />
              Deutschland
            </p>
            <p>
              <strong>Kontakt:</strong>
              <br />
              
            
              E-Mail: kizilkandev@gmail.com
            </p>
            <p>
              <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong>
              <br />
              Özkan Kizilkan
              <br />
              
            </p>
            <p>
              <strong>Haftungsausschluss:</strong>
              <br />
              Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine Haftung
              für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
              sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </>
        ) : (
          <>
            <p>
              <strong>Information in accordance with Section 5 TMG:</strong>
            </p>
            <p>
              Özkan Kizilkan
              <br />
              Freiligrathstraße 12  
              <br />
              10967 Berlin  
              <br />
              Germany
            </p>
            <p>
              <strong>Contact</strong>
              <br />
              
              Email: kizilkandev@gmail.com
            </p>
            <p>
              <strong>Responsible for content according to § 55 Abs. 2 RStV:</strong>
              <br />
              Özkan Kizilkan
              <br />
              <br />
            </p>
            <p>
              <strong>Liability for links</strong>
              <br />
              Despite careful content control, I assume no liability for the content
              of external links. The operators of the linked pages are solely
              responsible for their content.
            </p>
          </>
        )}
      </Container>
    </section>
  );
};
